import React, { ReactElement, useMemo } from "react";
import { QualityHubTaskListPanelProps } from "./QualityHubTaskListPanel.types";
import { QualityHubTaskListPanelGroup } from "../QualityHubTaskListPanelGroup";

/**
 * Renders a panel of task lists for the Quality Hub.
 *
 * @param {QualityHubTaskListPanelProps} props - The component props.
 * @returns {ReactElement} The rendered component.
 */
function QualityHubTaskListPanel({
    groups,
    onAddClick,
}: QualityHubTaskListPanelProps): ReactElement {
    const groupElements = useMemo(
        () => groups?.map((group) => (
            <div key={group.key}>
                <QualityHubTaskListPanelGroup group={group}
                                              onAddClick={onAddClick} />
            </div>
        )),
        [groups]);

    return (
        <div className="QualityHubTaskListPanel">
            {groupElements}
        </div>
    );
}

export default QualityHubTaskListPanel;

